var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"light","content":"Export to Image","open-delay":404,"placement":"top"}},[_c('i',{staticClass:"fas exportBtn",class:_vm.loading? 'fa-spin fa-spinner-third' : 'fa-save',on:{"click":e => _vm.export2Img(e)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }